// 课程列表
const registeredApp = () => import('@/pages/qihangAgree/registeredApp.vue');
export default [
  {
    path: '/registeredApp',
    component: registeredApp,
    meta: {
      title: '服务条款',
    },
  },

];
